export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE'
export const SET_EMPLOYEES = 'SET_EMPLOYEES'
export const SET_ADMIN_EMPLOYEES = 'SET_ADMIN_EMPLOYEES'
export const SET_TIME_CARDS = 'SET_TIME_CARDS'
export const SET_ROLES = 'SET_ROLES'
export const SET_INVITED_EMPLOYEES = 'SET_INVITED_EMPLOYEES'
export const SET_TIME_CARDS_ACTIVE = 'SET_TIME_CARDS_ACTIVE'



// WEBPACK FOOTER //
// ./src/types/employee.js